import {Support} from "@/store/api/supportApi";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface SupportState {
    supportList: Support[];
}

const initialState: SupportState = {
    supportList: [],
}

const supportSlice = createSlice({
    name: "support",
    initialState,
    reducers: {
        setSupportList: (state, action: PayloadAction<Support[]>) => {
            state.supportList = action.payload;
        },
        clearSupportList: (state) => {
            state.supportList = [];
        }
    }
})

export const {setSupportList, clearSupportList} = supportSlice.actions;
export default supportSlice.reducer;